import React from 'react'
import { Crown, Trophy } from 'lucide-react'
import BracketPlayerNames from './BracketPlayerNames'

/**
 * Shows the actual winner from a previous round when the user's pick was wrong.
 * This is the "inner" cell that appears between the user's two pick cells.
 *
 * Props:
 *  - team: team object with { seed, players }
 *  - teamSize: 1 for singles, 2 for doubles
 *  - isWinner: whether this team won the current match (green styling)
 *  - isChampionCorrect: champion was predicted AND won — shows Crown/Trophy icons
 *  - championTeamId: the user's champion team ID
 *  - showBorderB: whether to show a bottom border
 */
export default function BracketActualWinnerCell({
  team,
  teamSize = 1,
  isWinner = false,
  isChampionCorrect = false,
  showBorderB = false,
  // DUB-40: championship final — this cell shows the actual champion.
  isOfficialChampion = false,
  // owner 2026-06-06: the Crown means "your champion pick", so it only shows
  // when this team is the team the user picked to win it all. The Trophy marks
  // the actual champion regardless.
  isUserChampionPick = false,
}) {
  return (
    <div
      className={`w-full pl-3 pr-5 py-2.5 overflow-hidden flex-1 basis-0 bg-background ${showBorderB ? 'border-b border-[var(--color-bracket-card-border)]' : ''}`}
    >
      <div className="flex items-center gap-2 overflow-hidden">
        {team?.seed && (
          <span className="text-xs font-semibold w-6 flex-shrink-0 opacity-60">
            {/* DUB-134: consistent seed format — no `#`. */}
            {team.seed}
          </span>
        )}
        <div className="flex-1 min-w-0 overflow-hidden">
          <BracketPlayerNames
            team={team}
            className={isWinner ? 'font-semibold' : ''}
            teamSize={teamSize}
          />
        </div>
        {isWinner && !isOfficialChampion && (
          <span className="h-2 w-2 flex-shrink-0 rounded-full bg-[var(--mauve-8)]" />
        )}
        {/* Trophy = actual champion; Crown = the user's champion pick. */}
        {(isOfficialChampion || isChampionCorrect) && (
          <Trophy className="h-4 w-4 flex-shrink-0 text-[var(--color-crown)]" />
        )}
        {(isUserChampionPick || isChampionCorrect) && (
          <Crown className="h-4 w-4 flex-shrink-0 text-[var(--color-crown)]" />
        )}
      </div>
    </div>
  )
}
